export function usePath() {

    const mapPath = function (url: string){
        const cleanUrl = url.startsWith('/') ? url.slice(1) : url;

        return `/admin/${cleanUrl}`
    }


    return {
        mapPath
    }
}